<template>
  <div class="Hot_wire">
    <el-form :inline="true" style="padding: 15px;" class="demo-form-inline">
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">基本情况</div>
      <el-form-item>
        <template slot="label">
          <span><i style="color: red">*</i> 连接工单编号</span>
        </template>
        <el-input v-model="data.workNo" placeholder="连接工单编号"></el-input>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span><i style="color: red">*</i> 来电号码</span>
        </template>
        <!-- <el-input v-model="data.phone" placeholder="来电号码" maxlength="11" show-word-limit></el-input> -->
        <el-autocomplete
          class="inline-input"
          v-model="data.phone"
          show-word-limit
          :fetch-suggestions="querySearch"
          placeholder="请输入来电号码"
          :trigger-on-focus="false"
          @select="handleSelect"
        >
        <template slot-scope="{ item }">
          <div class="name">{{ item.Phone + '(' + item.RealName + ')' }}</div>
        </template>
      </el-autocomplete>
      </el-form-item>
      <el-form-item label="省份">
        <el-input v-model="data.province" placeholder="省份"></el-input>
      </el-form-item>
      <el-form-item label="城市">
        <el-input v-model="data.city" placeholder="城市"></el-input>
      </el-form-item>
      <el-form-item label="发生日期">
        <el-date-picker
          style="width: 202px;"
          v-model="data.happenDate"
          type="date"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="次数">
        <el-input v-model="data.times" placeholder="次数"></el-input>
      </el-form-item>
      <el-form-item label="是否为危机个案">
        <el-input v-model="data.isCrisis" placeholder="是否为危机个案"></el-input>
      </el-form-item>
      <el-form-item label="危机编号">
        <el-input v-model="data.crisiNo" placeholder="危机编号"></el-input>
      </el-form-item>
      <el-form-item label="总时间">
        <el-input v-model="data.totalTime" placeholder="总时间" @input.native="validateNumber($event, 'totalTime')"></el-input>
      </el-form-item>
      <!-- <el-form-item label="发生日期">
        <el-input v-model="data.a1" placeholder="发生日期"></el-input>
      </el-form-item> -->
      <el-form-item label="接线员">
        <el-input v-model="data.operator" placeholder="接线员"></el-input>
      </el-form-item>
      <el-form-item label="质量控制">
        <el-input v-model="data.qualityControl" placeholder="质量控制"></el-input>
      </el-form-item>
      <!-- <el-form-item label="发生日期">
        <el-input v-model="data.a1" placeholder="发生日期"></el-input>
      </el-form-item> -->
      <el-form-item label="曾用电话1">
        <el-input v-model="data.usedPhoneOne" placeholder="曾用电话1" maxlength="11" show-word-limit @input.native="validateNumber($event, 'usedPhoneOne')"></el-input>
      </el-form-item>
      <el-form-item label="曾用电话2">
        <el-input v-model="data.usedPhoneTwo" placeholder="曾用电话2" maxlength="11" show-word-limit @input.native="validateNumber($event, 'usedPhoneTwo')"></el-input>
      </el-form-item>
      <el-form-item label="曾用电话3">
        <el-input v-model="data.usedPhoneThree" placeholder="曾用电话3" maxlength="11" show-word-limit @input.native="validateNumber($event, 'usedPhoneThree')"></el-input>
      </el-form-item>
      <el-form-item label="曾用电话4">
        <el-input v-model="data.usedPhoneFour" placeholder="曾用电话4" maxlength="11" show-word-limit @input.native="validateNumber($event, 'usedPhoneFour')"></el-input>
      </el-form-item>
      <el-form-item label="首次工单号">
        <el-input v-model="data.firstWorkNo" placeholder="首次工单号"></el-input>
      </el-form-item>
      <el-form-item label="呼叫编号">
        <el-input v-model="data.callNumber" placeholder="呼叫编号"></el-input>
      </el-form-item>
      <el-form-item label="得知本热线">
        <el-input v-model="data.knowHotline" placeholder="得知本热线"></el-input>
      </el-form-item>
      <el-form-item label="专线">
        <el-input v-model="data.dedicatedLine" placeholder="专线"></el-input>
      </el-form-item>
      <el-form-item label="海外来电">
        <el-input v-model="data.overseasCalls" placeholder="海外来电"></el-input>
      </el-form-item>
      <el-form-item label="按键信息">
        <el-input v-model="data.keyInformation" placeholder="按键信息"></el-input>
      </el-form-item>
      <el-form-item label="性别">
        <el-input v-model="data.sex" placeholder="性别"></el-input>
      </el-form-item>
      <el-form-item label="年龄">
        <el-input v-model="data.years" placeholder="年龄" @input.native="validateNumber($event, 'years')"></el-input>
      </el-form-item>
      <el-form-item label="学历">
        <el-input v-model="data.degree" placeholder="学历"></el-input>
      </el-form-item>
      <el-form-item label="婚姻">
        <el-input v-model="data.marriage" placeholder="婚姻"></el-input>
      </el-form-item>
      <el-form-item label="主要职业">
        <el-input v-model="data.mainCareer" placeholder="主要职业"></el-input>
      </el-form-item>
      <el-form-item label="居住状态">
        <el-input v-model="data.residentialStatus" placeholder="居住状态"></el-input>
      </el-form-item>
      <el-form-item label="来电人员类型">
        <el-input v-model="data.personType" placeholder="来电人员类型"></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="data.name" placeholder="姓名"></el-input>
      </el-form-item>
      <el-form-item label="培养层次">
        <el-input v-model="data.trainLevel" placeholder="培养层次"></el-input>
      </el-form-item>
      <el-form-item label="培养单位">
        <el-input v-model="data.trainID" placeholder="培养单位"></el-input>
      </el-form-item>
      <el-form-item>
        <template slot="label">
          <span><i style="color: red">*</i> 学号</span>
        </template>
        <el-input v-model="data.userId" placeholder="学号"></el-input>
      </el-form-item>
      <el-form-item label="年级">
        <el-input v-model="data.entryDate" placeholder="年级"></el-input>
      </el-form-item>
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">来电主诉</div>
      <el-form-item label="来电类型">
        <el-input v-model="data.callType" placeholder="来电类型"></el-input>
      </el-form-item>
      <el-form-item label="既往治疗">
        <el-input v-model="data.psychotherapyHistory" placeholder="既往治疗1"></el-input>
      </el-form-item>
      <el-form-item label="既往诊断">
        <el-input v-model="data.psychotherapyDescribe" placeholder="既往诊断"></el-input>
      </el-form-item>

      <el-form-item label="现在治疗">
        <el-input v-model="data.psychotherapyNow" placeholder="现在治疗"></el-input>
      </el-form-item>

      <el-form-item label="精神状态">
        <el-input v-model="data.mentality" placeholder="现在治疗"></el-input>
      </el-form-item>

      <el-form-item label="主诉归类">
         <el-input type="textarea" placeholder="主诉归类" v-model="data.chiefcomplaintType"></el-input>
      </el-form-item>
      <el-form-item label="其他标签">
        <el-input type="textarea" placeholder="其他标签" v-model="data.otherLabel"></el-input>
      </el-form-item>
      <el-form-item label="目前用药">
        <el-input type="textarea" placeholder="目前用药" v-model="data.medicationNow"></el-input>
      </el-form-item>
      <el-form-item label="风险评估等级">
        <el-input v-model="data.urgentStatus" placeholder="风险评估等级"></el-input>
      </el-form-item>
      <el-form-item label="具体内容">
        <el-input type="textarea" placeholder="具体内容" v-model="data.detailContent"></el-input>
      </el-form-item>
      <el-form-item label="连接工作记录">
        <el-input type="textarea" placeholder="连接工作记录" v-model="data.answerPhoneRecord"></el-input>
      </el-form-item>
      <el-form-item label="结束情况">
        <el-input v-model="data.referralEnd" placeholder="结束情况"></el-input>
      </el-form-item>
      <el-form-item label="转介资源情况1">
        <el-input v-model="data.referralResourcesOne" placeholder="转介资源情况1"></el-input>
      </el-form-item>
      <el-form-item label="转介资源情况2">
        <el-input v-model="data.referralResourcesTwo" placeholder="转介资源情况2"></el-input>
      </el-form-item>
      <el-form-item label="转介资源情况3">
        <el-input v-model="data.referralResourcesThree" placeholder="转介资源情况3"></el-input>
      </el-form-item>
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">危机评估</div>
      <el-form-item label="自杀他杀类型">
        <el-input v-model="data.killType" placeholder="自杀他杀类型"></el-input>
      </el-form-item>
      <el-form-item label="个人自杀史">
        <el-input v-model="data.ownSuicideHistory" placeholder="个人自杀史1"></el-input>
      </el-form-item>
      <el-form-item label="个人自杀史描述">
        <el-input v-model="data.ownSuicideDiscribe" placeholder="个人自杀史2"></el-input>
      </el-form-item>

      <el-form-item label="亲友自杀史">
        <el-input v-model="data.friendSuicideHistory" placeholder="亲友自杀史1"></el-input>
      </el-form-item>
      <el-form-item label="亲友自杀史描述">
        <el-input v-model="data.friendSuicideDiscribe" placeholder="亲友自杀史2"></el-input>
      </el-form-item>

      <el-form-item label="自杀/他杀计划">
        <el-input v-model="data.killPlan" placeholder="自杀/他杀计划1"></el-input>
      </el-form-item>

      <el-form-item label="自杀/他杀计划细节">
        <el-input v-model="data.killPlanDetail" placeholder="自杀/他杀计划细节"></el-input>
      </el-form-item>

      <el-form-item label="自杀/他杀计划可能性">
        <el-input v-model="data.killFeasibility" placeholder="自杀/他杀计划可能性"></el-input>
      </el-form-item>
      <el-form-item label="自杀/他杀计划致命性">
        <el-input v-model="data.killFatality" placeholder="自杀/他杀计划致命性"></el-input>
      </el-form-item>
      <el-form-item label="现实压力">
        <el-input v-model="data.realisticPressure" placeholder="现实压力"></el-input>
      </el-form-item>
      <el-form-item label="社会支持">
        <el-input v-model="data.socialSupport" placeholder="社会支持"></el-input>
      </el-form-item>
      <el-form-item label="其他保护性资源">
        <el-input v-model="data.protectResources" placeholder="其他保护性资源"></el-input>
      </el-form-item>
      <el-form-item label="保密突破">
        <el-input v-model="data.secrecyThrough" placeholder="保密突破"></el-input>
      </el-form-item>
      <el-form-item label="来电者住址">
        <el-input v-model="data.callAddress" placeholder="来电者住址"></el-input>
      </el-form-item>
      <el-form-item label="身份证号">
        <el-input v-model="data.idCard" placeholder="身份证号" maxlength="18" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="紧急联系人">
        <el-input v-model="data.urgentContactName" placeholder="紧急联系人"></el-input>
      </el-form-item>
      <el-form-item label="与危机者关系">
        <el-input v-model="data.urgentRelation" placeholder="与危机者关系"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input v-model="data.contactPhone" placeholder="联系电话" maxlength="11" show-word-limit></el-input>
      </el-form-item>
      <el-form-item label="愿意透露">
        <el-input v-model="data.tellInformation" placeholder="愿意透露"></el-input>
      </el-form-item>
      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">危机详情</div>
      
      <el-form-item label="危机详情" class="qw">
        <el-input type="textarea" v-model="data.crisisDetail" placeholder="危机详情"></el-input>
      </el-form-item>

      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">热线干预措施</div>

      <el-form-item label="热线干预措施" class="qw">
        <el-input type="textarea" v-model="data.hotLineIntervene" placeholder="热线干预措施"></el-input>
      </el-form-item>

      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">联系结果</div>  

      <el-form-item label="编号1">
        <el-input v-model="data.contactNoOne" placeholder="编号1"></el-input>
      </el-form-item>

      <el-form-item label="结果1">
        <el-input v-model="data.contactResultsOne" placeholder="结果1"></el-input>
      </el-form-item>

      <el-form-item label="编号2">
        <el-input v-model="data.contactNoTwo" placeholder="编号2"></el-input>
      </el-form-item>

      <el-form-item label="结果2">
        <el-input v-model="data.contactResultsTwo" placeholder="结果2"></el-input>
      </el-form-item>

      <el-form-item label="编号3">
        <el-input v-model="data.contactNoThree" placeholder="编号3"></el-input>
      </el-form-item>

      <el-form-item label="结果3">
        <el-input v-model="data.contactResultsThree" placeholder="结果3"></el-input>
      </el-form-item>

      <el-form-item label="编号4">
        <el-input v-model="data.contactNoFour" placeholder="编号4"></el-input>
      </el-form-item>

      <el-form-item label="结果4">
        <el-input v-model="data.contactResultsFour" placeholder="结果4"></el-input>
      </el-form-item>

      <div style="font-weight: 700;font-size: 18px;padding-bottom:15px">危机随访者特征</div>

      <el-form-item label="随访情况">
        <el-input v-model="data.followUpType" placeholder="随访情况"></el-input>
      </el-form-item>

      <el-form-item label="随访者姓名">
        <el-input v-model="data.followUpName" placeholder="随访者姓名"></el-input>
      </el-form-item>

      <el-form-item label="与危机者关系">
        <el-input v-model="data.followUpRelation" placeholder="与危机者关系"></el-input>
      </el-form-item>

      <el-form-item label="随访电话1">
        <el-input v-model="data.followUpPhoneOne" placeholder="随访电话1" maxlength="11" show-word-limit @input.native="validateNumber($event, 'followUpPhoneOne')"></el-input>
      </el-form-item>

      <el-form-item label="随访电话2">
        <el-input v-model="data.followUpPhoneTwo" placeholder="随访电话2" maxlength="11" show-word-limit @input.native="validateNumber($event, 'followUpPhoneTwo')"></el-input>
      </el-form-item>

      <el-form-item label="危机者姓名">
        <el-input v-model="data.crisisName" placeholder="危机者姓名"></el-input>
      </el-form-item>

      <h2 style="font-size: 20px;  padding-bottom: 20px" v-if="data.parameter">"五困"类型及具体表现</h2>

      <el-form-item class="difficulty" label="学习困扰" v-if="data.parameter">
        <el-checkbox-group :max="3" v-model="data.parameter.studyDifficulty">
          <el-checkbox label="1" name="type">学业基础薄弱</el-checkbox>
          <el-checkbox label="2" name="type">学习能力差</el-checkbox>
          <el-checkbox label="3" name="type">科研能力差</el-checkbox>
          <el-checkbox label="4" name="type">缺乏专业兴趣</el-checkbox>
          <el-checkbox label="5" name="type">第一次挂科</el-checkbox>
          <el-checkbox label="6" name="type">多门挂科</el-checkbox>
          <el-checkbox label="7" name="type">缺课缺考</el-checkbox>
          <el-checkbox label="8" name="type">留级延期</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.studyDifficultyOther" placeholder="请输入学习困扰" maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-checkbox-group>
        
      </el-form-item>

      <el-form-item class="difficulty" label="生活困扰" v-if="data.parameter">
        <el-checkbox-group :max="3" v-model="data.parameter.lifeDifficulty">
          <el-checkbox label="1" name="type">经济困难</el-checkbox>
          <el-checkbox label="2" name="type">未获助学贷款</el-checkbox>
          <el-checkbox label="3" name="type">家庭重大变故</el-checkbox>
          <el-checkbox label="4" name="type">严重躯体疾病</el-checkbox>
          <el-checkbox label="5" name="type">生活自理困难</el-checkbox>
          <el-checkbox label="6" name="type">身体缺陷</el-checkbox>
          <el-checkbox label="7" name="type">语言困难</el-checkbox>
          <el-checkbox label="8" name="type">被骗被控制</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.lifeDifficultyOther" placeholder="请输入生活困难" maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item class="difficulty" label="交往困扰" v-if="data.parameter">
        <el-checkbox-group :max="3" v-model="data.parameter.contactDifficulty">
          <el-checkbox label="1" name="type">内向孤僻</el-checkbox>
          <el-checkbox label="2" name="type">退缩回避</el-checkbox>
          <el-checkbox label="3" name="type">适应不良</el-checkbox>
          <el-checkbox label="4" name="type">同学关系不良</el-checkbox>
          <el-checkbox label="5" name="type">师生关系不良</el-checkbox>
          <el-checkbox label="6" name="type">亲密关系不良</el-checkbox>
          <el-checkbox label="7" name="type">家庭关系不良</el-checkbox>
          <el-checkbox label="8" name="type">遭遇欺凌等</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.contactDifficultyOther" placeholder="请输入交往困难" maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item class="difficulty" label="发展困扰" v-if="data.parameter">
        <el-checkbox-group
          :max="3"
          v-model="data.parameter.developDifficulty"
        >
          <el-checkbox label="1" name="type">深感自卑</el-checkbox>
          <el-checkbox label="2" name="type">思想偏激</el-checkbox>
          <el-checkbox label="3" name="type">发展迷茫</el-checkbox>
          <el-checkbox label="4" name="type">过高期待</el-checkbox>
          <el-checkbox label="5" name="type">毕业困难</el-checkbox>
          <el-checkbox label="6" name="type">考研失败</el-checkbox>
          <el-checkbox label="7" name="type">就业困难</el-checkbox>
          <el-checkbox label="8" name="type">创业失败</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.developDifficultyOther" placeholder="请输入发展困难" maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-checkbox-group>
       
      </el-form-item>

      <el-form-item class="difficulty" label="心理困扰" v-if="data.parameter">
        <el-checkbox-group
          :max="3"
          style="position: relative"
          v-model="data.parameter.psyDifficulty"
        >
          <el-checkbox label="1" name="type">自杀伤人倾向</el-checkbox>
          <el-checkbox label="2" name="type">重性精神病</el-checkbox>
          <el-checkbox label="3" name="type">应激危机</el-checkbox>
          <el-checkbox label="4" name="type">人格问题</el-checkbox>
          <el-checkbox label="5" name="type">情绪障碍</el-checkbox>
          <el-checkbox label="6" name="type">成瘾行为</el-checkbox>
          <el-checkbox label="7" name="type">进食问题</el-checkbox>
          <el-checkbox label="8" name="type">睡眠问题</el-checkbox>
          <el-form-item label="其他" label-width="60px" style="display: inline-block;">
            <el-input style="width: 200px;" v-model="data.parameter.psyDifficultyOther" placeholder="请输入心理困难" maxlength="30" show-word-limit></el-input>
          </el-form-item>
        </el-checkbox-group>
      </el-form-item>

      <h2 style="font-size: 20px;padding-bottom: 20px">问题备注及应对工作（ <i style="color: red">*</i> 为必填项）</h2>

      <el-form-item class="cpwjzt" v-if="data.parameter">
        <template slot="label">
          <span><i style="color: red">*</i> 初评危机状态</span>
        </template>
        <el-radio v-model="data.parameter.firstCrisis" label="1">红色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="2">橙色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="3">黄色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="4">蓝色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="5">绿色预警</el-radio>
        <el-radio v-model="data.parameter.firstCrisis" label="6">无法确定</el-radio>
      </el-form-item>

      <div style="padding-bottom: 20px;" v-if="!IsIncrease">
        <el-form-item class="bgfbf2" label="热线管理员初核意见" style="padding-bottom: 20px;">
          <el-checkbox-group :max="3" v-model="hotlineDirectorChecks">
            <el-checkbox label="1" name="type">信息不完整</el-checkbox>
            <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
            <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
            <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br>
        <el-form-item label="热线管理员意见详情" class="nkjs bgfbf2">
          <el-input type="textarea" v-model="hotlineDirectorCheckDetail"></el-input>
        </el-form-item>
        <el-form-item class="bgfbf2" v-if="this.Global.pdroleid(1086) && type == '待热线管理员审核'">
          <el-button type="primary" @click="submit(3)">提交风险监控员</el-button>
          <el-button type="primary" @click="submit(2)">审核驳回</el-button>
        </el-form-item>
      </div>

      <div style="padding-bottom: 20px;" v-if="!IsIncrease">
        <el-form-item class="bgfbf2" label="风险监控员初核意见" style="padding-bottom: 20px;">
          <el-checkbox-group  :max="3" v-model="riskMonitorChecks">
            <el-checkbox label="1" name="type">信息不完整</el-checkbox>
            <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
            <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
            <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br>
        <el-form-item label="风险监控员意见详情" class="nkjs bgfbf2">
          <el-input type="textarea" v-model="riskMonitorCheckDetail"></el-input>
        </el-form-item>
        <el-form-item class="bgfbf2" v-if="this.Global.pdroleid(1069) && type == '待风险监控员初审'">
          <el-button type="primary" @click="submit(1)">审核确认</el-button>
          <el-button type="primary" @click="submit(2)">审核驳回</el-button>
          <el-button type="primary" @click="submit(3)">提交危机主管</el-button>
        </el-form-item>
      </div>


      <div style="padding-bottom: 20px;" v-if="(this.Global.pdroleid(1069) || this.Global.pdroleid(1070) || this.Global.pdroleid(1068)) && !IsIncrease">
        <el-form-item class="bgfbf2" label="危机主管初核意见" style="padding-bottom: 20px;">
          <el-checkbox-group  :max="3" v-model="criAdminChecks">
            <el-checkbox label="1" name="type">信息不完整</el-checkbox>
            <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
            <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
            <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br>
        <el-form-item label="危机主管意见详情" class="nkjs bgfbf2">
          <el-input type="textarea" v-model="criAdminCheckDetail"></el-input>
        </el-form-item>
        <el-form-item class="bgfbf2" v-if="this.Global.pdroleid(1068) && type == '待危机主管复核'">
          <el-button type="primary" @click="submit(1)">审核确认</el-button>
          <el-button type="primary" @click="submit(2)">审核驳回</el-button>
          <el-button type="primary" @click="submit(3)">提交中心主任</el-button>
        </el-form-item>
      </div>


      <div style="padding-bottom: 20px;" v-if="(this.Global.pdroleid(1070) || this.Global.pdroleid(1068)) && !IsIncrease">
        <el-form-item class="bgfbf2" label="中心主任意见" style="padding-bottom: 20px;">
          <el-checkbox-group  :max="3" v-model="centerDirectorChecks">
            <el-checkbox label="1" name="type">信息不完整</el-checkbox>
            <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
            <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
            <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br>
        <el-form-item label="中心主任意见详情" class="nkjs bgfbf2">
          <el-input type="textarea" v-model="centerDirectorCheckDetail"></el-input>
        </el-form-item>
        <el-form-item class="bgfbf2" v-if="this.Global.pdroleid(1070) && type == '待中心主任审核'">
          <el-button type="primary" @click="submit(1)">审核确认</el-button>
          <el-button type="primary" @click="submit(2)">审核驳回</el-button>
        </el-form-item>
      </div>


    </el-form>
    <div v-if="IsIncrease" style="padding-bottom: 20px;text-align: center;">
        <el-button type="primary" @click="Increase" :loading="Increaseloading">添加</el-button>
        <el-button @click="$router.go(-1)">返回</el-button>
      </div>
    


  </div>
</template>

<script>
export default {
  data(){
    return {
      data:{
        workNo: "",
        phone: "",
        province: "",
        city: "",
        happenDate: "",
        times: "",
        isCrisis: "",
        crisiNo: "",
        totalTime: "",
        operator: "",
        qualityControl: "",
        usedPhoneOne: "",
        usedPhoneTwo: "",
        usedPhoneThree: "",
        usedPhoneFour: "",
        firstWorkNo: "",
        callNumber: "",
        knowHotline: "",
        dedicatedLine: "",
        overseasCalls: "",
        keyInformation: "",
        sex: "",
        years: "",
        degree: "",
        marriage: "",
        mainCareer: "",
        residentialStatus: "",
        personType: "",
        name: "",
        userId: "",
        trainLevel: "",
        trainID: "",
        entryDate: "",
        callType: "",
        psychotherapyHistory: "",
        psychotherapyDescribe: "",
        psychotherapyNow: "",
        mentality: "",
        chiefcomplaintType: "",
        otherLabel: "",
        medicationNow: "",
        urgentStatus: "",
        detailContent: "",
        answerPhoneRecord: "",
        referralEnd: "",
        referralResourcesOne: "",
        referralResourcesTwo: "",
        referralResourcesThree: "",
        killType: "",
        ownSuicideHistory: "",
        ownSuicideDiscribe: "",
        friendSuicideHistory: "",
        friendSuicideDiscribe: "",
        killPlan: "",
        killPlanDetail: "",
        killFeasibility: "",
        killFatality: "",
        realisticPressure: "",
        socialSupport: "",
        protectResources: "",
        secrecyThrough: "",
        callAddress: "",
        idCard: "",
        urgentContactName: "",
        urgentRelation: "",
        contactPhone: "",
        tellInformation: "",
        crisisDetail: "",
        hotLineIntervene: "",
        contactNoOne: "",
        contactResultsOne: "",
        contactNoTwo: "",
        contactResultsTwo: "",
        contactNoThree: "",
        contactResultsThree: "",
        contactNoFour: "",
        contactResultsFour: "",
        followUpType: "",
        followUpName: "",
        followUpRelation: "",
        followUpPhoneOne: "",
        followUpPhoneTwo: "",
        crisisName: "",
        parameter:{
          studyDifficulty: [],
          lifeDifficulty: [],
          contactDifficulty: [],
          developDifficulty: [],
          studyDifficultyOther: '',
          lifeDifficultyOther: '',
          contactDifficultyOther: '',
          developDifficultyOther: '',
          firstCrisis: '',
          psyDifficulty: [],
          psyDifficultyOther: '',
        }
      },
      sourceNo:'',
      type:'',
      hotlineDirectorChecks:[],//热线管理员初核意见
      hotlineDirectorCheckDetail: '',//热线管理员意见详情
      riskMonitorChecks: [],//风险监控员审核意见
      riskMonitorCheckDetail: '',//风险监控员审核详细意见
      criAdminChecks: [],//危机主管审核意见
      criAdminCheckDetail: '',//危机主管审核详细意见
      centerDirectorChecks: [],//中心主任审核意见
      centerDirectorCheckDetail: '',//中心主任审核详细意见"
      IsIncrease:false,
      Increaseloading:false,

      
    }
  },
  mounted() {
    if(this.$route.query.sourceNo){
      this.IsIncrease=false;
      this.sourceNo = [this.$route.query.sourceNo][0];
      this.type = [this.$route.query.type][0];
      this.$Http_Post('hotline/hotlineReport/getInfo/'+this.sourceNo, ).then((res) => {
        if (res.Code == 0) {
          this.data = res.Data
        }
      });
      this.getprefabricatedTableData();
    }else{
      this.IsIncrease=true;
    }
  },
  methods:{
    validateNumber(event, field) {
      if (!event || !event.target) {
        return; // 确保 event.target 存在
      }

      const value = event.target.value;
      const numericValue = value.replace(/[^0-9]/g, ''); // 过滤非数字字符

      // 更新 ruleForm 中的相应字段
      this.data[field] = numericValue ? Number(numericValue) : null; // 转换为数字或设置为 null
    },
    querySearch(queryString, cb) {
      if (!queryString) {
        cb([]);
        return;
      }

      this.$Http_Post('/User/throughConditionGetUserList', { pageSize: 100, pageIndex: 1, phone: queryString }).then((res) => {
        const SUCCESS_CODES = [0, 200];
        if (SUCCESS_CODES.includes(res.Code)) {
          var restaurants = res.Data || [];
          if (restaurants.length > 0) {
            var results = restaurants.filter(this.createFilter(queryString));
            cb(results);
          } else {
            cb([]);
          }
        }
      });
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.Phone && restaurant.Phone.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      //this.data.workNo=item.UserID;
      this.data.phone = item.Phone;
      this.data.name = item.RealName;
      this.data.userId = item.UserID;
      this.data.sex = item.Sex==1?'男':'女';
      this.data.years = item.Years;
      this.data.degree = item.Degree;
      this.data.marriage = item.Marriage;
      this.data.trainID = item.TrainName;
      this.data.entryDate = item.EntryDate;
      this.data.province = item.Province;
      this.data.city = item.City;
      this.data.idCard = item.IDCard;
    },
    getprefabricatedTableData(){
      this.$Http_Post('/management/distressPrediction/prefabricatedTableData', { keyNo: [this.$route.query.KeyNo][0] }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.hotlineDirectorChecks = res.Data.hotlineDirectorChecks
          this.hotlineDirectorCheckDetail = res.Data.hotlineDirectorCheckDetail
          this.riskMonitorChecks =res.Data.riskMonitorChecks
          this.riskMonitorCheckDetail= res.Data.riskMonitorCheckDetail
          this.criAdminChecks =res.Data.criAdminChecks
          this.criAdminCheckDetail= res.Data.criAdminCheckDetail
          this.centerDirectorChecks= res.Data.centerDirectorChecks
          this.centerDirectorCheckDetail= res.Data.centerDirectorCheckDetail
        }
      });
    },
    submit(val) {
      this.$Http_Post('/DistressPrediction/DailyRiskMonitors', {
        keyNo:[this.$route.query.KeyNo][0],
        type:'热线上报',
        operate: val,
        hotlineDirectorChecks:this.hotlineDirectorChecks,
        hotlineDirectorCheckDetail:this.hotlineDirectorCheckDetail,
        riskMonitorChecks:this.riskMonitorChecks,
        riskMonitorCheckDetail:this.riskMonitorCheckDetail,
        criAdminChecks:this.criAdminChecks,
        criAdminCheckDetail:this.criAdminCheckDetail,
        centerDirectorChecks:this.centerDirectorChecks,
        centerDirectorCheckDetail:this.centerDirectorCheckDetail,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.$router.push({
            path: '/Crisis/Crisis_upreport'
          })
        }else{
          this.Global.request_failure(res.Message);
        }
      });
    },
    Increase(){
      if(this.data.parameter.firstCrisis==""){
        this.$message.error('请选择初评危机状态');
        return false
      }
      if(!this.data.workNo || this.data.workNo.trim() === ""){
        this.$message.error('请输入连接工单编号');
        return false
      }
      if(!this.data.phone || this.data.phone.trim() === ""){
        this.$message.error('请输入来电号码');
        return false
      }
      if(!this.data.userId || this.data.userId.trim() === ""){
        this.$message.error('请输入学号');
        return false
      }
      this.Increaseloading=true;
      this.$Http_Post('/hotline/hotlineReport/add',this.data).then(res=>{
        this.Increaseloading=false;
        if(res.Code==0 || res.Code==200){
          this.$message.success(res.Message);
          this.data=this.$options.data().data
        }else{
          this.$message.error(res.Message);
        }
      })
    }
  },

}
</script>

<style>
.Hot_wire {width: 100%;height: 100%;background-color: #fff;overflow: auto;}
/* .Hot_wire .el-form-item{width: 24%;} */
.Hot_wire .el-form--inline .el-form-item__label{width: 150px;}
.Hot_wire .el-form--inline .el-form-item__content{width: calc(100% - 150px);}
/* .Hot_wire .qw{width: 48%;} */
.Hot_wire .qw .el-form-item__content{width: 500px;}
.Hot_wire .bgfbf2{width: 1020px;}

.Hot_wire .nkjs .el-form-item__content{width: 600px !important;}
</style>